import { render, staticRenderFns } from "./SaxxCheckbox.vue?vue&type=template&id=c8771412"
import script from "./SaxxCheckbox.vue?vue&type=script&lang=js"
export * from "./SaxxCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports